import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MibIconComponent } from '@medinbox/angular';
import { PromptExampleIcon } from '@shared/models';

@Component({
  selector: 'mai-prompt-example-icon',
  imports: [MibIconComponent],
  templateUrl: './prompt-example-icon.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromptExampleIconComponent {
  readonly type = input.required<PromptExampleIcon>();
}
